import React from 'react';
import classNames from 'classnames';
import './Icon.scss';

// Todo: Properly migrate all of these types from Vanilla JS to TypeScript.
interface IconProps {
  glyph: any;
  size?: any;
  weight?: any;
  style?: any;
}

/*
 * FIX: Font Awesome icon rendering in Vite
 * ----------------------------------------
 * PROBLEM: The original component used an object format in classNames() with conditionals,
 * which can be processed differently by Vite's build process compared to CRA's webpack.
 * This led to inconsistent class application for icons.
 *
 * SOLUTION: Refactored this component to use explicit string class names and combine them more predictably.
 * 1. Parse each part of the class name separately (icon base class, glyph, weight, size)
 * 2. Combine them with explicit control over the final className string
 * 3. This gives more predictable results across different bundlers
 */
const Icon = ({ glyph, size, weight, style }: IconProps) => {
  // Make sure we're handling the class names correctly
  const iconClass: string = `fa-${glyph}`;

  // Map weight to Font Awesome prefix
  let weightClass: string = '';

  if (weight === 'light') {
    weightClass = 'fal';
  } else if (weight === 'solid') {
    weightClass = 'fas';
  } else if (weight === 'regular') {
    weightClass = 'far';
  } else if (weight === '') {
    weightClass = 'fa';
  }

  // Size class based on the passed size prop.
  const sizeClass: string = size ? `icon--${size}` : '';

  return (
    <i
      aria-hidden="true"
      className={classNames('icon', iconClass, weightClass, sizeClass)}
      style={style}
    />
  );
};

export default Icon;
